module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00024.bc1c4a2d.jpg";